import { PerformanceMarks } from '@fiverr-private/obs';
import { load } from '@fiverr-private/rum';
import getMetaTagValue from '../../../lib/getMetaTagValue';

(() => {
    if (typeof window.PerformanceObserver !== 'function') {
        return;
    }
    const version = getMetaTagValue('fiverrmeta:rum_version');
    if (!version) {
        return;
    }
    window.addEventListener(
        'load',
        () => performance.mark(PerformanceMarks.WINDOW_LOAD),
        { once: true }
    );
    load(version);
})();
